import { hasDefinedValue } from '@sgme/fp';
import { UnderlyingResults } from 'components/common-form/builder/form/node/field/BatchMultipleUnderlyingsField/MultipleUnderlyingsComponent/model';
import { CopyAllButton } from 'components/shared/CopyAllButton/CopyAllButton';
import { VerticalDivider } from 'components/shared/Divider';
import { WithUnderlyingInfoTooltip } from 'components/shared/UnderlyingInfo/WithUnderlyingInfoTooltip';
import { UnderlyingTag, UnderlyingTagBase } from 'components/underlying-tag';
import { FormattedMessage } from 'react-intl';

import { displayUnderlyingCode } from '../utils';

export function UnderlyingsResult({
  tags,
  invalidTags,
  isDisabled = false,
  onRemove,
  defaultUnderlyingCodeType,
  onValidTagRemovedAll,
  selectedUnderlyingsIds,
  isSingleUnderlyingSelection = false,
}: UnderlyingResults) {
  return (
    <>
      {invalidTags.map(({ value }) => (
        <UnderlyingTagBase key={value} label={value} variant="invalid" isReadOnly />
      ))}

      {tags.filter(hasDefinedValue('rawValue')).map(({ rawValue }) => {
        const color = getColor(isDisabled, rawValue.isRestricted);
        return (
          <div
            key={rawValue.id}
            className={`fs-6 my-1 row w-100 mx-0 px-0 align-items-center  py-0 alert alert-discreet-${color}`}
          >
            <div className="col-2 me-3">
              <UnderlyingTag
                dataE2e="multiple-underlyings-badge"
                label={displayUnderlyingCode(defaultUnderlyingCodeType, rawValue)}
                value={rawValue}
                isReadOnly
              />
            </div>
            <div className="col">{rawValue.name}</div>
            <div className="col-2 d-flex justify-content-end align-items-center px-0">
              <WithUnderlyingInfoTooltip underlying={rawValue} className="text-center">
                <i className={`icon icon-outlined  text-${color}`}>info</i>
              </WithUnderlyingInfoTooltip>
              <button className="btn btn-icon" onClick={() => onRemove(rawValue.id)}>
                <i className={`icon text-${color}`}>clear</i>
              </button>
            </div>
          </div>
        );
      })}

      <div className="align-self-end flex-grow-1 d-flex justify-content-end py-1">
        {!isSingleUnderlyingSelection && (
          <>
            <CopyAllButton className="btn-flat-secondary " disabled={isDisabled} values={selectedUnderlyingsIds} />
            <VerticalDivider className="mx-1" />
            <button
              className="btn btn-icon-end btn-flat-secondary d-flex "
              disabled={isDisabled}
              onClick={onValidTagRemovedAll}
              data-e2e="multiple-underlyings-remove-all-button"
            >
              <FormattedMessage id={'underlying.clearAll'} />
              <i className="icon">delete_outline</i>
            </button>
          </>
        )}
      </div>
    </>
  );
}
function getColor(isDisabled: boolean, isRestricted?: boolean) {
  if (isDisabled) {
    return 'secondary';
  }
  if (isRestricted) {
    return 'warning';
  }
  return 'info';
}
